<app-preloader *ngIf="isSubmitting" [loaderText]="'Submitting feedback...'"
  class="w-100 position-absolute preloader-backdrop">
</app-preloader>

<main class="container my-5" *ngIf="textJsonData">

  <div class="col-12 px-4">
    <h1 class="sr-only">Public Review</h1>
    <h2 class="title">{{currentConfigObj?.note}}</h2>
  </div>

  <div class="d-flex col-12 flex-wrap filter mt-4 p-4">
    <div class="row justify-content-between w-100">
      <div class="col-10">
        <p class="font-4x"> {{textJsonData?.instructionText}} </p>
      </div>

      <div class="col-auto p-0">
        <ng-container *ngIf="currentConfigObj?.metadata.length">
          <button type="button" class="btn btn-primary btn-sm border" data-toggle="modal" data-target="#userDetailPR"
            [disabled]="!finalObjToSubmit.comments?.length" (click)="clearInputs()">
            {{textJsonData?.feedbackSubmitBtnText}}
          </button>
        </ng-container>

        <ng-container *ngIf="(!currentConfigObj?.hasOwnProperty('metadata')) || currentConfigObj?.metadata?.length === 0">
          <button type="button" class="btn btn-primary btn-sm" id="submitBtn" (click)="saveDetails()"
            [disabled]="!finalObjToSubmit.comments?.length">
            Submit
          </button>
        </ng-container>
      </div>
    </div>
    <div class="col-12 d-flex p-0">
      <div class="dropdown col-4 pl-0">
        <app-auto-complete [listingObj]="publicReviewList" (selectedObject)="onPublicReviewSelected($event)"
          [selectType]="'single'" [uniqueId]="uniqueId" [propName]="title" [isLableShow]="true" [isMandatory]="false"
          [autoCompleteTitle]="textJsonData?.firstSelectionTitle" [showValidMsg]="false" [clrDisOnSelect]="false"
          [canDelete]="false" [index]='0' [disabled]=" !reviewListLoaded" [showSpinner]="!reviewListLoaded"
          #autoComplete_review>
        </app-auto-complete>
      </div>

      <div class="dropdown col-4" *ngIf="selectedReview && configFilterLevel?.length">
        <app-auto-complete [listingObj]="filteredNodeList[0]" (selectedObject)="onFilterLevelNodeSelected($event, 0)"
          [selectType]="'single'" [uniqueId]="'id'" [propName]="'display_name'" [isLableShow]="true"
          [isMandatory]="false" [autoCompleteTitle]="configFilterLevel[0]?.title" [showValidMsg]="false"
          [clrDisOnSelect]="false" [canDelete]="false" [index]='1' [disabled]="!nodesLoaded"
          [showSpinner]="!nodesLoaded" #autoComplete_node1>
        </app-auto-complete>
      </div>

      <div class="dropdown col-4" *ngIf="(configFilterLevel?.length > 1) && selectedFilterLevelNode">
        <app-auto-complete [listingObj]="filteredNodeList[1]" (selectedObject)="onNodeSelected($event)"
          [selectType]="'single'" [uniqueId]="'id'" [propName]="'display_name'" [isLableShow]="true"
          [isMandatory]="false" [autoCompleteTitle]="configFilterLevel[1]?.title" [showValidMsg]="false"
          [clrDisOnSelect]="false" [canDelete]="false" [index]='2' [disabled]="loadingNodes"
          [showSpinner]="loadingNodes" #autoComplete_node2>
        </app-auto-complete>
      </div>
    </div>


    <div class="col-12" *ngIf="textJsonData?.showThankYouText">
      <p class="mt-3 mb-0 font-3x d-flex align-items-center">
        <span class="d-inline-flex pr-1">Thanks for participating in the review. Would you like to
        </span>
        <button class="btn btn-clear font-3x p-0 text-underline" data-toggle="modal" data-target="#userDetailPR"
          [disabled]="!userInfoParams?.length">
          share some details about yourself? <span class="sr-only">Opens in a new dialog</span>
        </button>
      </p>
    </div>
  </div>

  <ng-container *ngIf="selectedNode">

    <ng-container *ngIf="selectedNode.children?.length">
      <div class="col-auto p-0 mt-4">
        <h3 id="nodeTitle" class="font-bold font-5x">{{selectedNode?.display_name}} </h3>
      </div>
      <div class="col-12 p-0 my-3">
        <app-tree-search #treeSearch [treeData]="selectedNode" [showFilter]="false"
          (searchEvent)="captureSearchEvent($event)" (loaderEvent)="setLoaderEvent($event)" [location]="'front-facing'"
          class="d-block mb-2">
        </app-tree-search>
      </div>
    </ng-container>

    <div class="col-12 p-0 mb-3">
      <div class="w-100 d-flex justify-content-between align-items-center">
        <div class="col p-0">
          <div class="d-flex">
            <ol class="breadcrumb mb-0 p-0" aria-hidden="true" tabindex="-1">
              <li class="breadcrumb-item">Document</li>
              <ng-container *ngFor="let type of nodeTypeList; let $index = index">
                <li class="breadcrumb-item" *ngIf="$index < (configFeedbackLevel[0] - 1)"
                  [ngClass]="{'active': $index ===( configFeedbackLevel[0] - 2)}">
                  {{type?.display_name}}
                </li>
              </ng-container>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <ng-container *ngIf="selectedNode.children?.length">
      <app-node-list [domain]="domain" [selectedNode]="selectedNode" [configDataObj]="currentConfigObj"
        [taxonomyId]="documentId" [isFilterApplied]="isFilterApplied" [searchResultList]="searchResultList"
        [isReset]="isReset" [isFeedbackNeeded]="true" (saveFeedbackEvent)="saveFeedback($event.detail)">
      </app-node-list>

    </ng-container>


  </ng-container>
</main>

<!-- Taxonomy Version Display Modal STARTS -->
<app-modal #userDetailPR [modalId]="'userDetailPR'" [modalSize]="'small'" [showHelp]="false"
  (closeEvent)="clearInputs()">
  <modal-div class="title-text" id="configtabeltitle">
    <span class="d-block w-100 font-4x">
      Review Participant's Details
    </span>
  </modal-div>
  <modal-div class="body-content">
    <div class="mb-4 col-5 p-0" *ngFor="let info of userInfoParams; let i = index">
      <label for="user{{info.user_metadata_name}}" class="font-bold mb-2 col px-1">{{info.user_metadata_name}}</label>
      <ng-container *ngIf="info.user_metadata_type === 1">
        <input id="user{{info.user_metadata_name}}" type="text" [(ngModel)]="info.user_metadata_value"
          class="form-control font-bold">
      </ng-container>
      <ng-container *ngIf="info.user_metadata_type === 2">
        <textarea id="user{{info.user_metadata_name}}" class="form-control font-bold"
          [attr.aria-label]="'Please enter '+info.user_metadata_name" [(ngModel)]="info.user_metadata_value"
          (keyup)="autoGrow('user'+info.user_metadata_name)" value="{{info.user_metadata_value}}"></textarea>
      </ng-container>
      <ng-container *ngIf="info.user_metadata_type === 3">
        <select id="user{{info.user_metadata_name}}" [(ngModel)]="info.user_metadata_value"
          class="form-control custom-select">
          <option [ngValue]="''">Select</option>
          <option [ngValue]="opt" *ngFor="let opt of info.user_metadata_possible_values ; let i =index"
            id="{{ opt?.split(' ').join('')+'label'+i }}">{{ opt }}</option>
        </select>

      </ng-container>
      <ng-container *ngIf="info.user_metadata_type === 4">
        <my-date-picker id="user{{info.user_metadata_name}}" [options]="myDatePickerOptionsStartDate"
          (dateChanged)="onCustomDateChanged($event, i)">
        </my-date-picker>
      </ng-container>
      <ng-container *ngIf="info.user_metadata_type === 5">
        <input class="form-control font-bold" id="user{{info.user_metadata_name}}" type="text"
          value="{{info.user_metadata_value ? info.user_metadata_value : ''}}" [(ngModel)]="info.user_metadata_value"  atp-time-picker />
      </ng-container>
      <ng-container *ngIf="info.user_metadata_type === 6">
        <input type="text" (keypress)="isNumber($event)" class="form-control font-bold"
          [(ngModel)]="info.user_metadata_value" id="user{{info.user_metadata_name}}"
          [attr.aria-label]="'Please enter '+info.user_metadata_name">
      </ng-container>
    </div>
    <div class="col-12 p-0">
      <p>To protect your personal data, we strictly adhere to the legal provisions governing the admissibility, and have
        taken appropriate technical and organizational precautions.</p>
      <ng-container *ngIf="!skipCaptchaValidation">
        <re-captcha #captchaElem (resolved)="resolved($event)" siteKey="{{siteKey}}"></re-captcha>
      </ng-container>
    </div>

  </modal-div>
  <modal-div class=" footer-buttons">
    <button type="button" class="btn btn-primary btn-sm" id="saveBtntd" data-dismiss="modal"
      [disabled]="(!skipCaptchaValidation && !captchaValidate)"
      (click)="saveDetails()">{{textJsonData?.modalSubmitBtnText}}</button>
  </modal-div>
</app-modal>
<!-- Taxonomy Version Display Modal ENDS -->
